<mat-toolbar class="mho-navbar" color="primary">
    <button mat-icon-button type="button" (click)="changeSidenavStatus.emit();">
        <mat-icon>menu</mat-icon>
    </button>
    <img class="logo" [ngSrc]="'img/logo/logo_mho_64x64.png'" height="30" width="30" priority alt="">
    <div class="title">{{ is_gt_sm() ? 'MyHordes Optimizer' : 'MHO' }}</div>

    <!-- Pastille de ville, masquée sous 600 px : elle passe alors en tête du menu. -->
    <mho-town-chip/>

    <span class="spacer"></span>
    <!-- Recherche globale : pages, objets, chantiers, bâtiments et, en ville, citoyens (`/` ou Ctrl+K).
         Sous 960 px, une loupe qui ouvre le champ sur toute la barre. -->
    <mho-global-search [compact]="!is_gt_sm()"/>
    <!-- Masqué en observation : la mise à jour porte toujours sur la ville du joueur, pas sur celle observée. -->
    @if (saved_external_app_id() && is_in_town() && !is_readonly()) {
        <mho-external-tools-update-button [isCompact]="!is_gt_sm()"/>
    }

    @if (is_dev) {
        <button mat-button type="button" class="profil-button" [matMenuTriggerFor]="userMenu">
            @if (saved_external_app_id() === null || saved_external_app_id() === undefined || saved_external_app_id() === '') {
                <ng-container i18n>Se connecter</ng-container>
            } @else if (me()) {
                @if (me()!.username && me()!.username !== '') {
                    <ng-container *ngTemplateOutlet="userIdentity"></ng-container>
                } @else {
                    <ng-container i18n>Utilisateur inconnu</ng-container>
                }
            } @else {
                <ng-container i18n>Utilisateur inconnu</ng-container>
            }
        </button>
    } @else {
        @if (saved_external_app_id() === null || saved_external_app_id() === undefined || saved_external_app_id() === '') {
            <a mat-button type="button" class="profil-button" [href]="myhordes_url + 'jx/disclaimer/' + myhordes_app_id">
                <ng-container i18n>Se connecter</ng-container>
            </a>
        } @else if (me()) {
            @if (me()!.username && me()!.username !== '') {
                <button mat-button type="button" class="profil-button" [matMenuTriggerFor]="userMenu">
                    <ng-container *ngTemplateOutlet="userIdentity"></ng-container>
                </button>
            } @else {
                <button mat-button type="button" class="profil-button" [matMenuTriggerFor]="userMenu">
                    <ng-container i18n>Utilisateur inconnu</ng-container>
                </button>
            }
        } @else {
            <button mat-button type="button" class="profil-button" [matMenuTriggerFor]="userMenu">
                <ng-container i18n>Utilisateur inconnu</ng-container>
            </button>
        }
    }

    <mat-menu #userMenu="matMenu">
        @if (!saved_external_app_id()) {
            <div mat-menu-item (click)="$event.stopPropagation()">
                <mat-form-field subscriptSizing="dynamic" class="external-app-id-input">
                    <mat-label i18n>Identifiant d'app externe</mat-label>
                    <input matInput type="text" placeholder="Identifiant externe pour les app" i18n-placeholder
                           [ngModel]="external_app_id_field_value()" (ngModelChange)="external_app_id_field_value.set($event)">
                    <button matSuffix mat-icon-button type="button" (click)="saveExternalAppId();" [disabled]="!external_app_id_field_value()">
                        <mat-icon>check</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        } @else {
            <!-- Item factice, caché : mat-menu calcule le décalage de positionnement de ses sous-menus
                 à partir de son PREMIER item direct (recherche qui ne traverse pas mho-header-citizen-menu).
                 Sans lui, ce premier item devient « Mon compte » (après tout le bloc citoyen), ce qui
                 décale tous les sous-menus de plusieurs centaines de pixels. -->
            <button mat-menu-item disabled style="display: none" tabindex="-1"></button>
            @if (me(); as me) {
                @if (me.town_details.town_id) {
                    <mho-header-citizen-menu></mho-header-citizen-menu>
                }
                @if (me.id) {
                    <a mat-menu-item [routerLink]="['/profile', me.id]" i18n>Mon compte</a>
                }
            }
            @if (admin_service.isAdmin()) {
                <a mat-menu-item [routerLink]="['/admin']" i18n>Administration</a>
            }
            <mat-divider></mat-divider>
            <div mat-menu-item (click)="disconnect()" i18n>Déconnexion</div>
        }
    </mat-menu>

    <!-- Identité : l'avatar MyHordes quand le joueur en a un, ses initiales sinon. L'avatar était
         déjà renvoyé par l'API et stocké, mais `private` dans le modèle : personne ne pouvait le
         lire. Sous 1280 px, le pseudo quitte la barre pour l'infobulle de l'avatar. -->
    <ng-template #userIdentity>
        <span class="identity" [matTooltip]="me()!.username" [matTooltipDisabled]="is_gt_md()">
            @if (me()!.avatar) {
                <mho-avatar class="avatar-img" rounded [size]="26" [src]="me()!.avatar ?? undefined"></mho-avatar>
            } @else {
                <span class="avatar" aria-hidden="true">{{ me()!.username.slice(0, 2) }}</span>
            }
            <span class="username">{{ me()!.username }}</span>
        </span>
    </ng-template>
</mat-toolbar>
